import { useMediaQuery } from '@chakra-ui/react';

const useIsWeb = () => {
  const [isWeb] = useMediaQuery('(min-width: 700px)');

  return isWeb;
};

export default useIsWeb;
